import React from "react";
import { useProducts } from "@/hooks/useProducts";
import { ProductCard } from "@/components/ProductCard";
import { Loader2 } from "lucide-react";

function PageHead({ script, title, sub }) {
  return (
    <div className="text-center max-w-2xl mx-auto mb-12">
      {script && <p className="font-script text-gold text-3xl mb-1">{script}</p>}
      <h1 className="font-serif text-4xl sm:text-5xl font-black text-cream tracking-tight">{title}</h1>
      {sub && <p className="text-cream/60 mt-4">{sub}</p>}
    </div>
  );
}

export default function PopcornShop() {
  const { products, loading } = useProducts("popcorn");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <PageHead script="Gourmet Popcorn Menu" title="Shop Popcorn" sub="Every batch is popped fresh and coated by hand. 3oz $5 · 6oz $8 · 10oz $12 — pick your size on each flavor." />
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-gold" size={40} /></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-testid="popcorn-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
